import type {ReactNode} from 'react';
import React from 'react'
import css from './SelectBox.less'
import cn from 'classnames'
import type {ClassValue, SelectOptions} from '../helpers/react-helpers';
import { selectOptions} from '../helpers/react-helpers'
import {EMPTY_OBJECT} from '../helpers/constants'

const ARROW = (
    <svg className={css.arrow} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
        <path d="M98.9 184.7l1.8 2.1 136 156.5c4.6 5.3 11.5 8.6 19.2 8.6 7.7 0 14.6-3.4 19.2-8.6L411 187.1l2.3-2.6c1.7-2.5 2.7-5.5 2.7-8.7 0-8.7-7.4-15.8-16.6-15.8H112.6c-9.2 0-16.6 7.1-16.6 15.8 0 3.3 1.1 6.4 2.9 8.9z" />
    </svg>
)

// const Arrow: React.FC<{ className: ClassValue }> = ({className}) => <svg className={cn(css.arrow,className)}
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 512 512">
//     <path d="M98.9 184.7l1.8 2.1 136 156.5c4.6 5.3 11.5 8.6 19.2 8.6 7.7 0 14.6-3.4 19.2-8.6L411
// 187.1l2.3-2.6c1.7-2.5 2.7-5.5 2.7-8.7 0-8.7-7.4-15.8-16.6-15.8H112.6c-9.2 0-16.6 7.1-16.6 15.8 0 3.3 1.1 6.4 2.9
// 8.9z" fill="currentColor" /> </svg>

export interface SelectBoxProps extends Pick<React.ComponentPropsWithoutRef<'select'>, 'id' | 'value' | 'onChange' | 'disabled' | 'onFocus' | 'onBlur' | 'required' | 'defaultValue' | 'style'> {
    className?: ClassValue
    children?: ReactNode,//ChildrenOfType<'option'>
    options?: SelectOptions
    placeholder?: string
    title?: string
    width?: React.CSSProperties['width'],
    minWidth?: React.CSSProperties['minWidth'],
    maxWidth?: React.CSSProperties['maxWidth'],
    //style: PartialStyle<'color' | 'backgroundColor' | 'borderColor' | 'minWidth' | 'maxWidth' | 'width'>
}

export default function SelectBox({
    id,
    children,
    value,
    onChange,
    style,
    className,
    defaultValue,
    disabled,
    onFocus,
    onBlur,
    required,
    title,
    width,
    minWidth,
    maxWidth,
    options,
    placeholder,
}: SelectBoxProps) {
    style ??= EMPTY_OBJECT
    const {color, backgroundColor, borderColor, ...otherStyle} = style
    const labelStyle: React.CSSProperties = {
        width,
        minWidth: minWidth ?? width,
        maxWidth,
        color,  // needed here to color the arrow; bug #761
        ...otherStyle,
    }
    const selectStyle: React.CSSProperties = {color, backgroundColor, borderColor}
    return (
        <label className={cn(css.wrap, (defaultValue || value) ? css.notEmpty : css.empty, disabled ? css.disabled : null, className)}
            title={title}
            style={labelStyle}>
            <select {...{
                id,
                value: value === null ? '' : value,
                onChange,
                disabled,
                onFocus,
                onBlur,
                required,
                defaultValue,
                style: selectStyle,
            }} className={css.select}>
                {placeholder ? <option value="" hidden>{placeholder}</option> : null}
                {children}
                {selectOptions(options)}
            </select>
            {ARROW}
        </label>
    )
}
